import { Highlight } from '../Highlight';
import { fromCamelCaseToWords } from '../../misc/functions';
import { NO_DATA } from '../../misc/misc.constants';
import type { Filters, Website } from '../../types';

interface RedirectCellProps {
  column: string;
  websiteData: Website;
  filters: Filters;
}

export function RedirectCell({
  column,
  websiteData,
  filters,
}: RedirectCellProps) {
  const value = websiteData[column] as string;

  return (
    <td data-title={fromCamelCaseToWords(column)} data-qa={column}>
      {value === NO_DATA ? (
        <Highlight text={value} highlight={filters[column]} />
      ) : (
        <a href={value} target="_blank" rel="noreferrer">
          <Highlight
            text={value.replace('https://', '').replace('/', '')}
            highlight={filters[column]}
          />
        </a>
      )}
    </td>
  );
}
